import { connect, ConnectedProps } from "react-redux";

import { IStoreState } from "../../../../../../../../reducers/types";
import { setAirportFilter } from "../../../../../../actions/actions";
import { getAirportFilter } from "../../../../../../reducer/index";
import { AirportFilterSelection } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    airportFilter: getAirportFilter(state),
  };
};

const mapDispatchToProps = {
  setAirportFilter,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AirportFilterProps = ConnectedProps<typeof connector>;

export const ConnectedAirportFilterSelection = connector(
  AirportFilterSelection
);
